module.exports = __webpack_public_path__ + "media/images/archived-909e49650c8e0f1fb4c7e8c895ecc347.png";